var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("system-demand-parameters")
            ? _c(
                "CardSimple",
                { attrs: { title: "System Demand Parameters" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c("InputYearly", {
                            attrs: {
                              "error-messages": _vm.$utils.getIfExists(
                                _vm.errors,
                                ["input", "demand_peak"]
                              ),
                              label: _vm.schema.demand_peak.title,
                              hint: _vm.schema.demand_peak.tooltip,
                              suffix: _vm.schema.demand_peak.unit,
                              type: "number",
                              num_years: _vm.num_years,
                              "start-year": _vm.startYear,
                              fill: "",
                              "spread-values": "",
                              "fill-value":
                                _vm.schema.demand_peak.items.default,
                              "chart-visible": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedInput.demand_peak,
                              callback: function ($$v) {
                                _vm.$set(_vm.computedInput, "demand_peak", $$v)
                              },
                              expression: "computedInput.demand_peak",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c("InputYearly", {
                            attrs: {
                              "error-messages": _vm.$utils.getIfExists(
                                _vm.errors,
                                ["input", "demand_annual"]
                              ),
                              label: _vm.schema.demand_annual.title,
                              hint: _vm.schema.demand_annual.tooltip,
                              suffix: _vm.schema.demand_annual.unit,
                              type: "number",
                              num_years: _vm.num_years,
                              "start-year": _vm.startYear,
                              fill: "",
                              "spread-values": "",
                              "fill-value":
                                _vm.schema.demand_annual.items.default,
                              chartVisible: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedInput.demand_annual,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedInput,
                                  "demand_annual",
                                  $$v
                                )
                              },
                              expression: "computedInput.demand_annual",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "12" } },
                        [
                          _c("InputYearlyProfile", {
                            attrs: {
                              title: _vm.schema.demand_profile.title,
                              suffix: _vm.schema.demand_profile.unit,
                              hint: _vm.schema.demand_profile.tooltip,
                              "error-messages": _vm.$utils.getIfExists(
                                _vm.errors,
                                ["input", "demand_profile"]
                              ),
                              num_years: _vm.num_years,
                              "start-year": _vm.startYear,
                              "profile-type": "DEMAND",
                              scaleProfile: function (data, year) {
                                return _vm.scale(
                                  data,
                                  _vm.input.demand_peak[year],
                                  _vm.input.demand_annual[year],
                                  year - 1 + _vm.startYear
                                )
                              },
                              fill: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: _vm.computedInput.demand_profile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.computedInput,
                                  "demand_profile",
                                  $$v
                                )
                              },
                              expression: "computedInput.demand_profile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("nodal-demands")
            ? _c(
                "Aggregate",
                _vm._b(
                  {
                    attrs: {
                      title: "Nodal Demands",
                      ItemConstructor: _vm.demandFactory,
                      headers: _vm.demandHeaders,
                      "copy-btn": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.bus_id",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodeIndex,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function (data) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(data.item.name) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "text-caption ml-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "(ID: " +
                                                    data.item.value +
                                                    ")"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: item.bus_id,
                                  callback: function ($$v) {
                                    _vm.$set(item, "bus_id", $$v)
                                  },
                                  expression: "item.bus_id",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.method",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.nodalDemandMethodItems,
                                  label: _vm.schemaDemand.method.title,
                                  "single-line": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.method,
                                  callback: function ($$v) {
                                    _vm.$set(item, "method", $$v)
                                  },
                                  expression: "item.method",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.active",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.schemaDemand.active.title,
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.active,
                                  callback: function ($$v) {
                                    _vm.$set(item, "active", $$v)
                                  },
                                  expression: "item.active",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              item.method
                                ? _c(
                                    "v-card",
                                    {
                                      staticClass: "pa-2 ma-2",
                                      attrs: { flat: "" },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "mb-6",
                                              attrs: { flat: "" },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-subtitle-1 font-weight-bold",
                                                },
                                                [_vm._v("General")]
                                              ),
                                              item.method ===
                                              "DEMAND_PARTICIPATION_FACTOR"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label:
                                                            "Active Power Participation",
                                                          hint: "Percentage of the system demand",
                                                          suffix: "%",
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "object-value": "",
                                                          "items-type":
                                                            "constant",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.active_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "active_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.active_power",
                                                        },
                                                      }),
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label:
                                                            "Reactive Power",
                                                          hint: "Not a participation factor unlike the active power",
                                                          suffix: "MVAR",
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "object-value": "",
                                                          "items-type":
                                                            "constant",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.reactive_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "reactive_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.reactive_power",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : item.method ===
                                                  "CONSTANT_POWER"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label: "Active Power",
                                                          suffix:
                                                            _vm.schemaDemand
                                                              .active_power
                                                              .unit,
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "fill-value":
                                                            _vm.schemaDemand
                                                              .active_power
                                                              .items.default
                                                              .value,
                                                          "object-value": "",
                                                          "items-type":
                                                            "constant",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.active_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "active_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.active_power",
                                                        },
                                                      }),
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label:
                                                            "Reactive Power",
                                                          suffix:
                                                            _vm.schemaDemand
                                                              .reactive_power
                                                              .unit,
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "fill-value":
                                                            _vm.schemaDemand
                                                              .reactive_power
                                                              .items.default
                                                              .value,
                                                          "object-value": "",
                                                          "items-type":
                                                            "constant",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.reactive_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "reactive_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.reactive_power",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : item.method === "PROFILE"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaDemand
                                                              .active_power
                                                              .title,
                                                          suffix:
                                                            _vm.schemaDemand
                                                              .active_power
                                                              .unit,
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "object-value": "",
                                                          "items-type":
                                                            "profile",
                                                          "profile-type":
                                                            "DEMAND",
                                                          scaleProfile: item
                                                            .active_power_scaling
                                                            .active
                                                            ? function (
                                                                data,
                                                                year
                                                              ) {
                                                                return _vm.scale(
                                                                  data,
                                                                  item
                                                                    .active_power_scaling
                                                                    .peak[year],
                                                                  item
                                                                    .active_power_scaling
                                                                    .annual[
                                                                    year
                                                                  ],
                                                                  year -
                                                                    1 +
                                                                    _vm.startYear
                                                                )
                                                              }
                                                            : null,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.active_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "active_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.active_power",
                                                        },
                                                      }),
                                                      _c("v-switch", {
                                                        attrs: {
                                                          color: "primary",
                                                          label:
                                                            "Active Profile Scaling",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item
                                                              .active_power_scaling
                                                              .active,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item.active_power_scaling,
                                                              "active",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.active_power_scaling.active",
                                                        },
                                                      }),
                                                      item.active_power_scaling
                                                        .active
                                                        ? _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    lg: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "InputYearly",
                                                                    {
                                                                      attrs: {
                                                                        hint: "Peak Demand",
                                                                        label:
                                                                          "Peak Demand",
                                                                        "hide-divider":
                                                                          "",
                                                                        type: "number",
                                                                        fill: "",
                                                                        "chart-visible":
                                                                          "",
                                                                        suffix:
                                                                          "MW",
                                                                        num_years:
                                                                          _vm.num_years,
                                                                        "start-year":
                                                                          _vm.startYear,
                                                                        "fill-value":
                                                                          _vm
                                                                            .schema
                                                                            .demand_peak
                                                                            .items
                                                                            .default,
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$emit(
                                                                              "change"
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item
                                                                            .active_power_scaling
                                                                            .peak,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item.active_power_scaling,
                                                                              "peak",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.active_power_scaling.peak",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    lg: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "InputYearly",
                                                                    {
                                                                      attrs: {
                                                                        hint: "Annual Demand",
                                                                        label:
                                                                          "Annual Demand",
                                                                        "hide-divider":
                                                                          "",
                                                                        type: "number",
                                                                        fill: "",
                                                                        "chart-visible":
                                                                          "",
                                                                        suffix:
                                                                          "GWh",
                                                                        num_years:
                                                                          _vm.num_years,
                                                                        "start-year":
                                                                          _vm.startYear,
                                                                        "fill-value":
                                                                          _vm
                                                                            .schema
                                                                            .demand_annual
                                                                            .items
                                                                            .default,
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$emit(
                                                                              "change"
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item
                                                                            .active_power_scaling
                                                                            .annual,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item.active_power_scaling,
                                                                              "annual",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.active_power_scaling.annual",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c("InputYearlyProfile", {
                                                        attrs: {
                                                          label:
                                                            _vm.schemaDemand
                                                              .reactive_power
                                                              .title,
                                                          suffix:
                                                            _vm.schemaDemand
                                                              .reactive_power
                                                              .unit,
                                                          num_years:
                                                            _vm.num_years,
                                                          "start-year":
                                                            _vm.startYear,
                                                          fill: "",
                                                          "object-value": "",
                                                          "items-type":
                                                            "profile",
                                                          "profile-type":
                                                            "DEMAND",
                                                          scaleProfile: item
                                                            .reactive_power_scaling
                                                            .active
                                                            ? function (
                                                                data,
                                                                year
                                                              ) {
                                                                return _vm.scale(
                                                                  data,
                                                                  item
                                                                    .reactive_power_scaling
                                                                    .peak[year],
                                                                  item
                                                                    .reactive_power_scaling
                                                                    .annual[
                                                                    year
                                                                  ],
                                                                  year -
                                                                    1 +
                                                                    _vm.startYear
                                                                )
                                                              }
                                                            : null,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item.reactive_power,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "reactive_power",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.reactive_power",
                                                        },
                                                      }),
                                                      _c("v-switch", {
                                                        attrs: {
                                                          color: "primary",
                                                          label:
                                                            "Reactive Profile Scaling",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item
                                                              .reactive_power_scaling
                                                              .active,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item.reactive_power_scaling,
                                                              "active",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.reactive_power_scaling.active",
                                                        },
                                                      }),
                                                      item
                                                        .reactive_power_scaling
                                                        .active
                                                        ? _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    lg: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "InputYearly",
                                                                    {
                                                                      attrs: {
                                                                        hint: "Peak Demand",
                                                                        label:
                                                                          "Peak Demand",
                                                                        "hide-divider":
                                                                          "",
                                                                        type: "number",
                                                                        fill: "",
                                                                        "chart-visible":
                                                                          "",
                                                                        suffix:
                                                                          "MW",
                                                                        num_years:
                                                                          _vm.num_years,
                                                                        "start-year":
                                                                          _vm.startYear,
                                                                        "fill-value":
                                                                          _vm
                                                                            .schema
                                                                            .demand_peak
                                                                            .items
                                                                            .default,
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$emit(
                                                                              "change"
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item
                                                                            .reactive_power_scaling
                                                                            .peak,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item.reactive_power_scaling,
                                                                              "peak",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.reactive_power_scaling.peak",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    lg: "6",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "InputYearly",
                                                                    {
                                                                      attrs: {
                                                                        hint: "Annual Demand",
                                                                        label:
                                                                          "Annual Demand",
                                                                        "hide-divider":
                                                                          "",
                                                                        type: "number",
                                                                        fill: "",
                                                                        "chart-visible":
                                                                          "",
                                                                        suffix:
                                                                          "GWh",
                                                                        num_years:
                                                                          _vm.num_years,
                                                                        "start-year":
                                                                          _vm.startYear,
                                                                        "fill-value":
                                                                          _vm
                                                                            .schema
                                                                            .demand_annual
                                                                            .items
                                                                            .default,
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$emit(
                                                                              "change"
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item
                                                                            .reactive_power_scaling
                                                                            .annual,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item.reactive_power_scaling,
                                                                              "annual",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.reactive_power_scaling.annual",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c("InputYearly", {
                                                attrs: {
                                                  label:
                                                    _vm.schemaDemand.voll.title,
                                                  hint: "Cost of unserved electricity demand",
                                                  num_years: _vm.num_years,
                                                  "start-year": _vm.startYear,
                                                  "persistent-hint": "",
                                                  fill: "",
                                                  suffix:
                                                    _vm.schemaDemand.voll.unit,
                                                  type: "number",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.voll,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "voll", $$v)
                                                  },
                                                  expression: "item.voll",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedInput.demands,
                      callback: function ($$v) {
                        _vm.$set(_vm.computedInput, "demands", $$v)
                      },
                      expression: "computedInput.demands",
                    },
                  },
                  "Aggregate",
                  _vm.$attrs,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _vm.isRequired("demand-response")
            ? _c("SystemDemandResponse", {
                attrs: {
                  "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                    "input",
                    "demand_response",
                  ]),
                  reserves: _vm.input.reserves,
                  num_years: _vm.num_years,
                  "start-year": _vm.startYear,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedInput.demand_response,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedInput, "demand_response", $$v)
                  },
                  expression: "computedInput.demand_response",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }